import httpClient from "../httpClient";
import { API_PROCEDURE_UPDATE } from "../config";

const updateProcedureInfo = {
    updateInfo: (id, data) => httpClient.post(API_PROCEDURE_UPDATE + '/' + id, data),
};

export default updateProcedureInfo;
